import css from 'styled-jsx/css';

import { rgba, defaultTheme } from 'common/styling/theme';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .PaymentProofForm {
    box-shadow: 0 1px 6px 1px rgba(0, 0, 0, 0.06);
    margin-bottom: rem(25px);
    padding: rem(25px 30px 10px);
    &:first-child {
      margin-top: rem(20px);
    }
    @include respond-to(sm) {
      padding: rem(20px 15px 10px);
    }
  }

  .PaymentProofForm__caption {
    h2 {
      margin-bottom: 20px;
    }
    p {
      font-size: 14px;
      line-height: 16px;
      display: block;
      margin-bottom: 25px;
    }
  }

  .DocumentsForm__upload {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    margin-bottom: 30px;
  }

  .DocumentsForm__upload-text {
    position: relative;
    padding-left: 35px;
    width: 50%;
    @include respond-to(sm) {
      width: 100%;
      margin-bottom: 15px;
    }
    &:after {
      content: '';
      height: 2px;
      width: 23px;
      transform: rotate(-51deg);
      position: absolute;
      left: 6px;
      top: 9px;
    }
    i {
      height: 2px;
      width: 13px;
      transform: rotate(50deg);
      position: absolute;
      left: 0;
      top: 13px;
    }
    p {
      margin-bottom: 3px;
    }
    :global(span) {
      font-size: 13px;
    }
  }

  .DocumentsForm__upload-button {
    @include respond-to(sm) {
      width: 100%;
      text-align: right;
    }
    button {
      text-transform: uppercase;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 1px;
    }
  }

  .Document__status-verified {
    display: block;
    position: relative;
    padding: rem(0 0 3px 35px);
    font-size: rem(17px);
    margin-bottom: 20px;
    &:after {
      content: '';
      height: 2px;
      width: rem(23px);
      transform: rotate(-51deg);
      position: absolute;
      left: rem(6px);
      top: 35%;
    }
    i {
      height: 2px;
      width: rem(13px);
      transform: rotate(50deg);
      position: absolute;
      left: 0;
      top: 50%;
    }
  }

  .PaymentProofForm {
    &--no-approve {
      display: none;
    }

    &__withdrawal-proof {
      padding: 0 0 15px 0;
    }

    &__withdrawal-proof-download {}
  }

  // 存款已上传凭证预览卡片：与 KYC Upload Documents 文件缩略图一致
  // （styled-jsx 作用域隔离，KYC 的 .DocumentsLoadPanel__file-* 样式不会落到这里，需自带）
  .DocumentsLoadPanel__files {
    display: flex;
    flex-wrap: wrap;
    gap: rem(10px);
    margin: rem(12px) 0 rem(15px);
  }

  .DocumentsLoadPanel__file {
    position: relative;
    width: rem(88px);
    height: rem(60px);
    border: 2px solid #dadada;
    border-radius: rem(8px);
    background: #fff;
    transition: box-shadow 0.2s ease;
    @include respond-to(sm) {
      width: rem(58px);
      height: rem(40px);
    }
    &:hover {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    // 文件预览区：撑满卡片内容区并裁切圆角（半径略小于卡片，避开 2px 边框）
    &-media {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      overflow: hidden;
      border-radius: rem(6px);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  // 图片缩略图：本组件直接渲染的 <button><img>，用 object-fit: contain 缩放原图，
  // 保证始终贴合卡片尺寸，不按原图大小溢出
  .DocumentsLoadPanel__file-thumb {
    display: block;
    width: 100%;
    height: 100%;
    padding: 0;
    border: none;
    background: transparent;
    cursor: zoom-in;
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
      transition: transform 0.2s ease;
    }
    &:hover {
      img {
        transform: scale(1.05);
      }
    }
  }

  .DocumentsLoadPanel__file-nonimage {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.2s ease;
    &:hover {
      background-color: rgba(0, 0, 0, 0.03);
    }
    img {
      // 图标放大到贴近卡片边框（原 45%/55% 太小，四周留白过多）
      max-width: 88%;
      max-height: 88%;
      object-fit: contain;
    }
  }

  // 删除按钮：仅 unverified 凭证显示，缩略图右上角红色 hover ×（与 KYC 一致）
  .DocumentsLoadPanel__file-delete {
    position: absolute;
    top: rem(-7px);
    right: rem(-7px);
    z-index: 2;
    width: rem(22px);
    height: rem(22px);
    padding: 0;
    border: 1px solid #e0e0e0;
    border-radius: 50%;
    background: #fff;
    color: #9aa0a8;
    font-size: rem(15px);
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
    transition: color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
    &:hover {
      color: #e5484d;
      border-color: #e5484d;
      box-shadow: 0 2px 8px rgba(229, 72, 77, 0.28);
    }
  }

  // 已审核通过角标：缩略图右上角绿色圆点对勾（占据原删除按钮位置，verified 不显示删除）。
  // 绿色背景必须放在 staticStyles 里：与 KYC 一致，颜色主题无关（defaultTheme 模块级 success 色）。
  .DocumentsLoadPanel__file-verified {
    position: absolute;
    top: rem(-7px);
    right: rem(-7px);
    z-index: 2;
    width: rem(18px);
    height: rem(18px);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${defaultTheme.colors.success.hex};
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
    i {
      width: rem(6px);
      height: rem(10px);
      border: solid #fff;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
      margin-top: rem(-2px); // 旋转后的对勾视觉重心略偏上，微调居中
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css`
    .PaymentProofForm {
      background-color: ${colors.white.hex};
    }

    .DocumentsForm__upload {
      background: ${rgba([colors.warning.rgb, 0.35])};
    }

    .DocumentsForm__upload-text {
      &:after,
      i {
        background: ${colors.success.hex};
      }
    }

    .DocumentsForm__upload-button {
      button {
        color: ${colors.primary.hex};
        &:hover {
          color: ${colors.secondary.hex};
        }
      }
    }

    .Document__status-verified {
      color: ${colors.success.hex};
      &:after,
      i {
        background: ${colors.success.hex};
      }
    }

    .PaymentProofForm__error {
      color: ${colors.error.hex};
      margin: -15px 0 10px;
      display: block;
      width: 100%;
    }
  `;
};

export { staticStyles, getDynamicStyles };
